export enum CompanyLocalStorage {
  KEY = 'companyFilterKey',
  TYPE = 'companyFilterType',
  START_DATE = 'companyFilterStartDate',
  END_DATE = 'companyFilterEndDate',
  IS_WHITE_MARK = 'companyFilterIsWhiteMark',
  DISTRIBUTOR_ID = 'companyFilterDistributorId',
  GROUP_ID = 'companyFilterGroupId',
  BRANCH_ID = 'companyFilterBranchId',
}
